module.exports = __webpack_public_path__ + "static/media/create-member.8555a185.png";